import React from "react";
import { Box, Typography } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";

const EmptyState: React.FC = () => {
  return (
    <Box className="res-no-data-container">
      <Box className="res-no-data-icon">
        <ErrorOutline />
      </Box>
      <Typography variant="h6" className="res-no-data-text">
        No analytics data available
      </Typography>
      <Typography className="res-no-data-subtext">Try adjusting your time range or check back later</Typography>
    </Box>
  );
};

export default EmptyState;
